import { Timestamp, FieldValue } from 'firebase/firestore';

/**
 * Interface da coleção principal: usuarios
 * Caminho: usuarios/{uid}
 */
export interface UsuarioFirestore {
  uid: string;
  nome: string;
  empresa: string;
  whatsapp: string;
  cnpj_cpf: string;
  total_gasto_mes: number;
  total_gasto_acumulado: number;
  criado_em: Timestamp | FieldValue | Date | string;
}

/**
 * Interface da subcoleção: usuarios/{uid}/enderecos_salvos
 */
export interface EnderecoSalvoFirestore {
  id?: string;
  apelido: string;
  rua: string;
  numero: string;
  bairro: string;
  cidade: string;
  cep: string;
  complemento?: string;
  contato: string;
  telefone: string;
}

export interface PontoEnderecoCorrida {
  rua: string;
  numero: string;
  bairro: string;
  cidade: string;
  cep: string;
  complemento?: string;
  contato: string;
  telefone: string;
  instrucoes?: string;
}

export interface ParadaCorrida extends PontoEnderecoCorrida {
  ordem?: number;
}

export type StatusCorrida = 'pendente' | 'aceita' | 'em_andamento' | 'concluida' | 'cancelada';
export type FormaPagamentoCorrida = 'pix' | 'cartao' | 'faturado' | 'dinheiro' | string;

/**
 * Interface da coleção principal: corridas
 * Caminho: corridas/{corrida_id}
 * Campo expiracao_ttl configurado para deleção automática após 20 dias.
 */
export interface CorridaFirestore {
  id?: string;
  cliente_id: string;
  status: StatusCorrida;
  coleta: PontoEnderecoCorrida;
  paradas: ParadaCorrida[];
  entrega: PontoEnderecoCorrida;
  valor_bruto: number;
  desconto_taxa_aplicada: number;
  valor_final: number;
  valor_total: number;
  forma_pagamento: FormaPagamentoCorrida;
  valor_pago?: number;
  troco_necessario?: number;
  link_pagamento_cartao?: string;
  criado_em: Timestamp | FieldValue | Date | string;
  expiracao_ttl: Timestamp | FieldValue | Date | string;
}

/**
 * Interface da subcoleção: corridas/{corrida_id}/mensagens
 */
export interface MensagemCorridaFirestore {
  id?: string;
  remetente_id: string;
  tipo_usuario: 'cliente' | 'operador';
  texto: string;
  imagem_url?: string;
  enviado_em: Timestamp | FieldValue | Date | string;
}

/**
 * Função utilitária para calcular a data de expiração do TTL (20 dias a partir da criação da corrida).
 */
export function calcularExpiracaoTTL(dataCriacao: Date = new Date()): Date {
  const DIAS_TTL = 20;
  const expiracao = new Date(dataCriacao.getTime());
  expiracao.setDate(expiracao.getDate() + DIAS_TTL);
  return expiracao;
}
